import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TemporaryTeamService} from "../../../../../core/services/temporary-team.service";
import {PopupHelperService} from "../../../../../core/services/popup-helper.service";
import {EventManagerService} from "../../../../../core/services/event-manager.service";
import {ParticipateService} from "../../../../../core/services/participate.service";
import {ChallengeService} from "../../../../../core/services/challenge.service";
import {StorageService} from "../../../../../core/services/storage.service";
import {Router, RouterLink} from "@angular/router";
import {TeamsService} from "../../../../../core/services/teams.service";
import {TournamentService} from "../../../../../core/services/tournament.service";
import {AsyncPipe, NgIf} from "@angular/common";
import {ImageWrapperComponent} from "../../../../components/image-wrapper/image-wrapper.component";
import {TimerPipe} from "../../../../pipes/timer.pipe";
import {TranslateModule} from "@ngx-translate/core";
import {PrimaryButtonComponent} from "../../../../components/primary-button/primary-button.component";

@Component({
  selector: 'app-team-invitation-widget-item',
  templateUrl: './team-invitation-widget-item.component.html',
  standalone: true,
  imports: [
    NgIf,
    ImageWrapperComponent,
    TimerPipe,
    AsyncPipe,
    TranslateModule,
    PrimaryButtonComponent,
    RouterLink
  ],
  styleUrls: ['./team-invitation-widget-item.component.scss']
})
export class TeamInvitationWidgetItemComponent implements OnInit {

  @Input() invitation: any;
  @Output() closeWidget = new EventEmitter();
  private sponsorVideoUrls: any[] =[];
  constructor(private temporaryTeamService: TemporaryTeamService,
              private teamsService: TeamsService,
              private popupHelperService: PopupHelperService,
              private eventManagerService: EventManagerService,
              private participateService: ParticipateService,
              private challengeService: ChallengeService,
              private tournamentService: TournamentService,
              private router: Router) { }

  public profileData: any
  public showUnsubscribe: boolean = false
  public participateRequestSend: boolean = false
  public buttonLoad = false
  ngOnInit(): void {
  }

  cancel(){
    if(this.buttonLoad){
      return
    }
    this.buttonLoad = true
    if(!this.invitation.fromParticipantId){
      this.teamsService.cancelInvite(this.invitation._id).subscribe((data: any) =>{
        this.buttonLoad = false
        this.eventManagerService.closeNotifyContent()
        if(!data.hasError){
        }else {
          this.popupHelperService.printError({text: data.errorMessages[0].msg})
        }
      })
    }else {
      this.temporaryTeamService.cancelInvite(this.invitation._id).subscribe((data: any) =>{
        this.buttonLoad = false
        this.eventManagerService.closeNotifyContent()
        if(!data.hasError){
        }else {
          this.popupHelperService.printError({text: data.errorMessages[0].msg})
        }
      })
    }
  }


  accept(){
    if(this.buttonLoad){
      return
    }
    this.buttonLoad = true
    if(!this.invitation.fromParticipantId){
      this.teamsService.acceptInvite(this.invitation._id).subscribe((data: any) =>{
        this.buttonLoad = false
        this.closeWidget.emit()
        this.eventManagerService.closeNotifyContent()
        if(!data.hasError){
          this.router.navigate(['/teams/', this.invitation.teamId])
        }else {
          this.popupHelperService.printError({text: data.errorMessages[0].msg})
        }
      })
    }else {
    this.temporaryTeamService.acceptInvite(this.invitation._id).subscribe((data: any) =>{
      this.buttonLoad = false
      this.eventManagerService.closeNotifyContent()
      if(!data.hasError){
        this.closeWidget.emit()
      }else {
          if(data.errorMessages[0].code === '1003333'){
            this.closeWidget.emit()
            this.profileData = StorageService.getJsonItem(StorageService.statics.profileData)
            if(this.profileData && this.profileData.notifyEvents){
              let index = this.profileData.notifyEvents.map(function (e:any) {
                return e.forId;
              }).indexOf(this.invitation.forId._id)
              if(index >= 0){
                this.showUnsubscribe = true
              }
            }

            if(this.invitation.forTable === 'challenge'){
              this.challengeService.getPopupInfoById(this.invitation.forId._id).subscribe((data: any) => {
                if(!data.hasError){
                  this.setPopupInfo(data.data.challenge, 'challenge')
                }else {
                  this.popupHelperService.printError({text: data.errorMessages[0].msg})
                }
              })
            }else{
              this.tournamentService.getPopupInfoById(this.invitation.forId._id).subscribe((data: any) => {
                if(!data.hasError){
                  this.setPopupInfo(data.data.tournament, 'tournament')
                }else {
                  this.popupHelperService.printError({text: data.errorMessages[0].msg})
                }
              })
            }

          }else {
            this.popupHelperService.printError({text: data.errorMessages[0].msg})
          }
          //this.popupHelperService.printError({text: data.errorMessages[0].msg})
        }
      })

    }
  }

  setPopupInfo(forEvent: any, forTable: string){
    StorageService.setItem(StorageService.statics.lastAction, 'join');
    let description
    if(forTable === 'challenge'){
      description = forEvent.challengeTemplateId.rules
    }else if(forTable === 'tournament'){
      description = forEvent.tournamentTemplateId.rules
    }
    if (forEvent.sponsoredBy && forEvent.sponsoredBy.length) {
      for (let i in forEvent.sponsoredBy) {
        if (forEvent.sponsoredBy[i].videoLink)
          this.sponsorVideoUrls.push({
              sponsorId:forEvent.sponsoredBy[i]._id,
              adUrl:forEvent.sponsoredBy[i].videoLink
            })

      }
    }
    if(this.invitation.forId.payByTeamLeader){
      this.eventManagerService.betOnMeBetModal({
        cb:this.participate.bind(this),
        tickets: this.invitation.forId.enterTickets,
        description: description,
        forTable: this.invitation.forTable,
        teamInvitationId: this.invitation._id,
        forId: this.invitation.forId._id,
        payByTeamLeader: this.invitation.forId.payByTeamLeader,
        openByPayByTeamLeaderInvite: true,
        videoAdvertisement:this.sponsorVideoUrls,
        invitationPlayerType: this.invitation.invitationPlayerType
      })

    }else {
      this.eventManagerService.betOnMeBetModal({
        cb:this.participate.bind(this),
        teamInvitationId: this.invitation._id,
        tickets: this.invitation.forId.enterTickets,
        forTable: this.invitation.forTable,
        forId: this.invitation.forId._id,
        description: description,
        videoAdvertisement:this.sponsorVideoUrls,
        invitationPlayerType: this.invitation.invitationPlayerType
      })
    }

  }


  participate(betPaymentMethod: string){
    if(this.participateRequestSend){
      return
    }
    this.participateRequestSend = true;
    this.eventManagerService.taskManagementModalEmitter.emit({event:'close'});
    this.participateService.participate(this.invitation.forTable, this.invitation.forId._id, betPaymentMethod, this.invitation._id).subscribe((data: any) => {
      this.participateRequestSend = false;
      if(!data.hasError){
        this.eventManagerService.updateHomePage.emit();
      } else {
        this.popupHelperService.printError({text: data.errorMessages[0].msg})
      }
    }, () => {
      this.participateRequestSend = false;
      this.participateRequestSend = false
      this.popupHelperService.printError('Something went wrong!')
    })
  }

  goToUserPage(userId: string){
    this.router.navigate(['/player/', userId]);
  }

}
